import type { ShearConnectionDTO } from '@api/fastAPI.schemas'

export const serializeShearConnectionForClipboard = (connection: ShearConnectionDTO): string =>
  JSON.stringify(connection, null, 2)

export const isShearConnectionClipboardPayload = (value: unknown): value is ShearConnectionDTO => {
  if (!value || typeof value !== 'object') return false

  const candidate = value as Partial<ShearConnectionDTO>

  // The spacing is what tells a Schubverbinder from a Zugverbinder, which
  // otherwise carries the same name and resistances.
  return (
    typeof candidate.name === 'string' &&
    typeof candidate.distance === 'number' &&
    typeof candidate.r_d_earthquake === 'number' &&
    typeof candidate.r_d_wind === 'number'
  )
}

export const parseShearConnectionFromClipboardText = (text: string): ShearConnectionDTO | null => {
  if (!text.trim()) return null

  try {
    const parsed: unknown = JSON.parse(text)
    return isShearConnectionClipboardPayload(parsed) ? parsed : null
  } catch {
    return null
  }
}

export const preparePastedShearConnection = (
  connection: ShearConnectionDTO,
): ShearConnectionDTO => ({
  ...connection,
  guid: crypto.randomUUID(),
  name: `${connection.name} (Kopie)`,
  export_comment: connection.export_comment ?? '',
})
